import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';

// decoratorsBeforeExport: true
@Module({
    namespaced: true,
})
export default class CompositionExportModule extends VuexModule {
    public key: string = 'CompositionExport.compositions';

    public compositions: object[] = [];
}
